import { render } from "./ControlPanel.vue?vue&type=template&id=132ef6a3&scoped=true&ts=true"
import script from "./ControlPanel.vue?vue&type=script&lang=ts"
export * from "./ControlPanel.vue?vue&type=script&lang=ts"

import "./ControlPanel.vue?vue&type=style&index=0&id=132ef6a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132ef6a3"]])

export default __exports__